// dispatchHelper unwraps `payload.data` on HTTP 200. A failed App Fixer envelope can
// therefore arrive as `{reason}` with no `success` flag, or as `(undefined, undefined)`
// when the transport error has an empty body. Normalize those into the error channel.
const readAppFixerResult = ({ result, failure } = {}) => {
  if (failure) {
    return { data: undefined, error: failure };
  }
  if (result?.success === false) {
    return { data: undefined, error: result };
  }
  if (result === undefined) {
    return { data: undefined, error: { message: 'The request did not complete.' } };
  }
  return { data: result, error: undefined };
};

export default readAppFixerResult;
